// extracted by mini-css-extract-plugin
export default {"areaText":"CustomTextArea_areaText__9ZM5E"};